import React, { PropTypes, Component } from 'react';
import styles from './Styles';
import TaskResultList from './TaskResultList';
import CheckBoxTaskResult from './CheckBoxTaskResult';
import { mixin, RefluxMixin } from 'Util';
import * as SvgIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import { IconButton, RaisedButton } from 'material-ui';
import { CourseActions, QuizActions } from 'actions';
import Embed from 'components/Page/Module/Embed';
import { translate as _l } from 'oxygen-i18n';

const classes = oxygenCss({
  comment: {
    marginLeft: '10px',
    background: '#fff0cb',
    padding: '5px 10px',
    width: 'calc(100% - 40px)'
  },
});

export default class RadioTask extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  constructor(props) {
    super(props);
    CourseActions.answerTaskComplete.listen(props.isQuiz ? QuizActions.updateAnswer : () => { })
    let choices = {};
    if (this.props.answered) {
      this.props.answered.forEach(key => {
        choices[key] = true
      })
    }
    this.state = {
      choices,
      hasAnswered: false
    }
  }

  choose(index) {
    let { choices } = this.state;
    choices[index] = !choices[index];
    this.setState({ choices });
    QuizActions.updateAnswer()
  }

  answer = () => {
    let { pageModuleId, taskId, id } = this.props;
    const { choices } = this.state;

    this.setState({ hasAnswered: true });

    let value = Object.keys(choices)
      .filter(choice => choices[choice])
      .map(choice => parseInt(choice, 10));
    CourseActions.answerTask(taskId || id, pageModuleId, { value });
    this.props.gaTracking && this.props.gaTracking();
    if (this.props.isQuiz && this.props.displayNextQuizQuestion) {
      QuizActions.next();
    }
  }

  renderAnswerControls() {
    const { themeColor } = this.props;
    return (
      <div style={styles.answerControls}>
        <RaisedButton
          onTouchTap={this.answer}
          fullWidth={true}
          backgroundColor={themeColor}
          labelColor="#FFF"
          label={this.context.getIntlMessage('tasks.answer')}
        />
      </div>
    );
  }

  renderTaskResultList() {
    const {
      showTaskResultOnAnswer,
      caption,
      taskResults,
      correctResponse,
      reader,
    } = this.props;

    let results = taskResults;

    if (showTaskResultOnAnswer) {
      if (!this.state.hasAnswered || !taskResults) {
        return null;
      }

      const lastAnswer = taskResults[taskResults.length - 1];
      results = [lastAnswer];
    }

    return (
      <TaskResultList
        reader={reader}
        correctResponse={correctResponse}
        ListElement={CheckBoxTaskResult}
        results={results}
        choices={caption.items}
        removeAnimation={showTaskResultOnAnswer}
      />
    )
  }

  render() {
    let {
      caption,
      captionFiles,
      frontend,
      taskResults,
      correctResponse,
      canAnswer,
      file,
      reader,
      canEdit
    } = this.props;
    let correctAnswers = (correctResponse && correctResponse.value) || [];
    let choices = caption.items.map((item, index) => {
      let icon;
      if (canAnswer) {
        if (this.state.choices[index]) {
          icon = (
            <IconButton
              style={styles.radio}
              onTouchTap={this.choose.bind(this, index)}
            >
              <SvgIcons.ToggleCheckBox
                color={Colors.Colors.green[800].material}
              />
            </IconButton>
          );
        } else {
          icon = (
            <IconButton
              style={styles.radio}
              onTouchTap={this.choose.bind(this, index)}
            >
              <SvgIcons.ToggleCheckBoxOutlineBlank />
            </IconButton>
          );
        }
      } else {
        icon = <SvgIcons.ToggleCheckBoxOutlineBlank style={styles.radio} />;
      }

      return (
        <div style={styles.label} key={index}>
          {icon}
          {item}
        </div>
      );
    });
    let answerControls;
    if (canAnswer && !canEdit) {
      answerControls = this.renderAnswerControls();
    }
    let external = null;
    try {
      external = JSON.parse((this.props.frontend && this.props.frontend[0]) || null);
    } catch (err) { }
    let fileType = null;
    let File = file ? file : external ? { ...external, type: 'external' } : captionFiles && captionFiles[0];
    let ext;
    if (File && File.type.includes('image')) {
      ext = File.type.replace(/\/(jpeg|jpg|png|webp)/g, '')
    } else if (File && File.type.includes('video')) {
      ext = File.type.replace(/\/(mp4)/g, '')
    } else if (File && File.type.includes('audio')) {
      ext = File.type.replace(/\/(mp4|x-m4a)/g, '')
    } else if (File && File.type === 'external') {
      ext = 'external'
    }
    switch (ext) {
      case 'video':
        fileType = (
          <video style={{ width: '100%' }} controls alt={File.name}>
            <source
              src={File.url.includes('.mp4') ? File.url : File.url + '.mp4'}
              type={File.type}
            />
          </video>
        )
        break;

      case 'image':
        fileType = (
          <img style={{ width: '100%' }} src={File.url} alt={File.name} />
        )
        break;

      case 'audio':
        fileType = (
          <audio controls style={{ width: '100%' }}>
            <source
              src={File.url}
              type={File.type}
            />
          </audio>
        )
        break;

      case 'external':
        fileType = <Embed provider={File.provider} id={File.id} />
        break;

      default:
        break;
    }

    return (
      <div>
        {File && fileType}
        <div style={styles.question}>{caption.main}</div>
        <div style={styles.choices}>{choices}</div>
        {answerControls}
        {this.renderTaskResultList()}
        {caption &&
          caption.comment &&
          taskResults &&
          taskResults[taskResults.length - 1] &&
          !!diff(
            taskResults[taskResults.length - 1].body.value,
            correctResponse.value
          ).length && (
            <div className={classes.comment}>
              <h5>{_l`comment`}</h5>
              <i>{caption.comment}</i>
            </div>
          )}
      </div>
    );
  }
}

function diff(a, b) {
  return b.filter(i => {
    return a.indexOf(i) < 0;
  });
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/CheckBoxTask.js